module.exports = __webpack_public_path__ + "static/1057_Globe_150_Logo_BLK-f121a066bbeeb7f4ffdecb5933fbc949.png";